/**
 * Adds accessible dropdown functionality to main navigation.
 *
 * Toggles open/closed on click, as click is better for accessibility.
 * Hover does not show intent and can be problematic for some users.
 */
function mainNavigation() {
    // Select all menu items that have a dropdown menu
    const allMenuItems = document.querySelectorAll(".main-navigation li.menu-item-has-children");
    const menuItems = Array.from(allMenuItems).filter((item) => {
    return !item.closest(".sidebar");
    });
  
    // Add event listeners for click and keyboard
    menuItems.forEach((el) => {
      const anchor = el.querySelector("a");
      anchor.addEventListener("click", openDropdownMenu);
      anchor.addEventListener("keydown", dropdownKeydownHandler);
    });
  
    // Close dropdowns when clicking outside
    document.addEventListener("click", closeAllDropdownsOnClickOutside);
  }
  mainNavigation();
  
  // Open dropdown menu and close others
  function openDropdownMenu(event) {
    event.stopPropagation();
    event.preventDefault();
  
    const currentItem = event.target.parentNode;
    const openItems = document.querySelectorAll("li.menu-item-has-children.open");
  
    openItems.forEach((item) => {
      if (item !== currentItem) {
        item.classList.remove("open");
        item.querySelector("a").setAttribute("aria-expanded", "false");
      }
    });
  
    currentItem.classList.toggle("open");
    event.target.setAttribute(
      "aria-expanded",
      currentItem.classList.contains("open") ? "true" : "false"
    );
  }
  
  // If spacebar or enter is pressed, open the dropdown
  function dropdownKeydownHandler(event) {
    if (event.code === "Space" || event.code === "Enter") {
      event.preventDefault();
      openDropdownMenu.call(this, event);
    }
  }
  
  // Close all dropdowns when clicking outside
  function closeAllDropdownsOnClickOutside() {
    const openItems = document.querySelectorAll("li.menu-item-has-children.open");
  
    openItems.forEach((item) => {
      item.classList.remove("open");
      item.querySelector("a").setAttribute("aria-expanded", "false");
    });
  }
  
  jQuery(".menu-wrapper").menuLevel({
    repeatParentInSub: true,
    backLabel: "Back",
    backAriaLabel: "Back",
  });
  
  export { mainNavigation };
  